import { render, staticRenderFns } from "./CommentBlock.vue?vue&type=template&id=7a25f8b4&"
import script from "./CommentBlock.vue?vue&type=script&lang=ts&"
export * from "./CommentBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CommentBlock.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports